













































/* Created- 20 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ParticaEvent, getActionName, eParticaAction } from "../../Models/ParticaEvent";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaCardXl from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import { ButtonType, ButtonStatus, ButtonConfig } from "../../Models/Buttons";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaAccountBase from "../Base/ParticaAccountBase.vue";
import { IArticleLicenceService } from "../../BusinessServices/accountlicence";
import { CustomerArticleLicenceDTO, AccountArticleLicenceDTO } from "../../Generated/ParticaAPI";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import CustomerArticleLicenceForm from "@/Ui-Components/ArticleLicence/ArticleLicence.vue";
import ArticleLicences from "../../Ui-Components/ArticleLicence/ArticleLicences.vue";
import { IArticle } from "../../Models/ArticleModels/article";
import { IParticaStoreService } from "../../BusinessServices/particastore";
import ArticleLicenceTable from "../../Ui-Components/ArticleLicence/ArticleLicenceTable.vue";

@Component(
	{
		name: "AccountLicencing",
		components: {
			ParticaView,
			ParticaCardXl,
			ButtonList,
			ParticaRightDrawer,
			CustomerArticleLicenceForm,
			ArticleLicences,
			ArticleLicenceTable
		}
	})
export default class AccountLicencing extends ParticaAccountBase {
	@Prop() private id: number;
	private service: IArticleLicenceService;
	private selectedlicence: CustomerArticleLicenceDTO = new CustomerArticleLicenceDTO();
	private data: CustomerArticleLicenceDTO[] = [];
	private showlicence: boolean = false;
	private showassign: boolean = false;
	private licence: CustomerArticleLicenceDTO = new CustomerArticleLicenceDTO();
	private articles: AccountArticleLicenceDTO[] = [];
	private buttons: ButtonConfig[] = [
		{
			label: "Add Article Licence",
			action: eParticaAction.ADD_ARTICLE_LICENCE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled

		} as ButtonConfig,
		{
			label: "Assign Article Licences",
			action: eParticaAction.ASSIGN_ARTICLE_LICENCE,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled

		} as ButtonConfig
	];
	private licencebuttons: ButtonConfig[] = [
		{
			label: "Save Article Licence",
			action: eParticaAction.SAVE_ARTICLE_LICENCE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled

		} as ButtonConfig,
		{
			label: "Make Default Licence",
			action: eParticaAction.MAKE_LICENCE_DEFAULT,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled

		} as ButtonConfig
	];
	private selectedbuttons: ButtonConfig[] = [
		{
			label: "Change Licence",
			action: eParticaAction.CHANGE_ARTICLE_LICENCE,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled

		} as ButtonConfig
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CHANGE_ARTICLE_LICENCE: {
					const selectedArticles: AccountArticleLicenceDTO[] = event.item as AccountArticleLicenceDTO[];
					const updateArticles: number[] = [];
					selectedArticles.forEach(article => {
						if (article.selected === true) {
							updateArticles.push(article.articleId as number);
						}
					});
					await this.service.UpdateArticleLicences(this.id, updateArticles, this.selectedlicence.customerArticleLicenceId as number);
					this.articles = await this.service.getProofArticles(this.id);
					break;
				}
				case eParticaAction.LEFT_MOUSE_CLICK: {
					(event.item as AccountArticleLicenceDTO).selected = !(event.item as AccountArticleLicenceDTO).selected;
					break;
				}
				case eParticaAction.ASSIGN_ARTICLE_LICENCE: {
					this.articles = await this.service.getProofArticles(this.id);
					this.showassign = true;
					break;
				}

				case eParticaAction.MAKE_LICENCE_DEFAULT: {
					this.licence = event.item as CustomerArticleLicenceDTO;
					await this.service.makeDefault(this.id as number, this.licence.customerArticleLicenceId as number);
					this.showlicence = false;
					await this.init();
					break;
				}
				case eParticaAction.SELECT_ARTICLE_LICENCE: {
					this.licence = event.item as CustomerArticleLicenceDTO;
					this.showlicence = true;
					break;
				}
				case eParticaAction.ADD_ARTICLE_LICENCE: {
					this.licence = new CustomerArticleLicenceDTO();
					this.licence.customerAccountId = this.id;
					this.showlicence = true;
					break;
				}
				case eParticaAction.SAVE_ARTICLE_LICENCE: {
					this.licence.customerAccountId = this.id;
					this.licence = await this.service.saveLicence(this.licence);
					await this.init();
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Account Article Licences";
		this.service = this.particaServices.getArticleLicenceService();
		this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.data = await this.service.getLicences(this.id);
			if (this.data.length > 0) {
				this.selectedlicence = this.data[0];
			}
			await this.getAccountNav(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
